module.exports = __webpack_public_path__ + "img/FooterJmc.24e6c24d.png";